/**
 * @generated SignedSource<<3983128c5a16a17a69cf809397a0f77f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SubscribeContactToListDialogMailingListsQuery$variables = Record<PropertyKey, never>;
export type SubscribeContactToListDialogMailingListsQuery$data = {
  readonly mailingLists: ReadonlyArray<{
    readonly __typename: "MailingList";
    readonly id: string;
    readonly mailingListIdentifier: string;
    readonly name: string;
    readonly subscribedCount: number;
  }>;
};
export type SubscribeContactToListDialogMailingListsQuery = {
  response: SubscribeContactToListDialogMailingListsQuery$data;
  variables: SubscribeContactToListDialogMailingListsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MailingList",
    "kind": "LinkedField",
    "name": "mailingLists",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mailingListIdentifier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subscribedCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscribeContactToListDialogMailingListsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SubscribeContactToListDialogMailingListsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "18742d937c09f9a877b064727a68a270",
    "id": null,
    "metadata": {},
    "name": "SubscribeContactToListDialogMailingListsQuery",
    "operationKind": "query",
    "text": "query SubscribeContactToListDialogMailingListsQuery {\n  mailingLists {\n    __typename\n    id\n    mailingListIdentifier\n    name\n    subscribedCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "d8ca2a4260cab7ae263f790a47046746";

export default node;
